import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { Locale } from '@/i18n'
import { createLogger } from '@/lib/log/client'

const log = createLogger('date-utils')

// Note: have to import every locale, so probably move any
// i18n-able helpers to a single file.
// Note: app router, not sure what that last note means
dayjs.extend(utc)

export { formatSecondsToTime } from './time-utils'

export const formatDate = (dateString: string, locale: Locale) => {
  try {
    const date = dayjs.utc(dateString).locale(locale ?? 'en')
    return date.format('MMM D, YYYY')
  } catch (ex) {
    log.error(ex)
    // logRemotelyClient('formatDate got %s: %o', dateString, ex);
    return ''
  }
}

// get month year from date string
export const formatMonthYearDate = (dateString: string, locale: Locale) => {
  try {
    const date = dayjs.utc(dateString).locale(locale ?? 'en')
    return date.format('MMM YYYY')
  } catch (ex) {
    log.error(ex)
    // logRemotelyClient('formatMonthYearDate got %s: %o', dateString, ex);
    return ''
  }
}
